import { Theme } from '@mui/material';
import colorSystem from 'src/scss/_colors-system.module.scss';

const styleOverrideSelect = (theme: Theme) => ({
  '& .MuiSelect-filled': {
    backgroundColor: colorSystem.nneutroState100,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: colorSystem.nneutroState500,
  },
  '&.Mui-focused': {
    '&:after': {
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
  },
});

export default styleOverrideSelect;
